import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { GroupService } from './../../../core/services/group.service';
import { redirectToLogin } from '../../../core/utils/login-redirect.util';

@Component({
  selector: 'app-reject-invite',
  templateUrl: './reject-invite.component.html',
  styleUrls: ['./reject-invite.component.scss']
})
export class RejectInviteComponent extends BaseComponent {
  inviteToken?: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private groupService: GroupService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.inviteToken = params['token'];
    });
  }

  rejectInvite() {
    const sub = this.groupService.rejectInvite(this.inviteToken!).subscribe(
      response => {
        this.showToastMessage('Invite rejected successfully.')
        // Handle successful invite rejection
        this.router.navigate(['/patients', 'schedule']);
        sub.unsubscribe();
      },
      error => {
        this.showToastMessage(error.error.message);
        console.error('Error rejecting invite:', error);
        // One navigation to a freshly loaded /login — see `redirectToLogin`.
        redirectToLogin();
        sub.unsubscribe();
      }
    );
  }

  cancel() {
    // One navigation to a freshly loaded /login — see `redirectToLogin`.
    redirectToLogin();
  }
}
